import { useState } from "react";
import { toast } from "react-toastify";
import { useForm, UseFormReturn } from "react-hook-form";
import { ApiData } from "../ApiData";

type ContactFormReturn = {
  formMethods: UseFormReturn;
  onSubmit: (data: any) => void;
  isFormSent: boolean;
  onChangeRecaptcha: (value: string) => void;
};

export const useContactForm = <
  TFormValues extends Record<string, any> = Record<string, any>
>(): ContactFormReturn => {
  const formMethods = useForm();
  const [isFormSent, setIsFormSent] = useState(false);
  let isInProgress = false;
  let recaptchaResponse: string = null;

  const onChangeRecaptcha = (value: string) => {
    recaptchaResponse = value;
  };

  const onSubmit = async (data: any) => {
    if (isInProgress) return;
    isInProgress = true;

    if (!recaptchaResponse) {
      return toast.error("Please fill out the reCAPTCHA!");
    }

    data["g-recaptcha-response"] = recaptchaResponse;
    const result = await ApiData.publicApiRequest(data, "send_ticket");

    if (result.success) {
      toast.success("Successful!");
      setIsFormSent(true);
      window.scrollTo(0, 0);
    } else {
      toast.error(result.message);
      isInProgress = false;
    }
  };

  return {
    formMethods,
    onSubmit,
    isFormSent,
    onChangeRecaptcha,
  };
};
